// darkMode.js
import moonwhite from '../utils/lightmode.svg';
import moonblack from '../utils/moon-black.svg';
import linkedinDark from '../utils/Contacts/linkedin-dark.svg'
import linkedinWhite from '../utils/Contacts//linkedin-light.svg'
import mailDark from '../utils/Contacts/mail-dark.svg'
import mailWhite from '../utils/Contacts/mail-light.svg'
import githubDark from '../utils/Contacts/github-dark.svg'
import githubWhite from '../utils/Contacts/github-light.svg'
import mediumlight from '../utils/Contacts/medium-light.svg'
import mediumdark from '../utils/Contacts/medium-dark.svg'
import menu_light from '../utils/menu-light.svg'
import menu_dark from '../utils/menu-dark.svg'
import logo_dark from '../utils/logo/logo-white.png'
import logo_white from '../utils/logo/logo-black.png'


export function initializeDarkMode() {
  let storedDarkMode = localStorage.getItem("darkmode");
  if (storedDarkMode === null) {
    storedDarkMode = "disabled";
    localStorage.setItem("darkmode", "disabled");
  }
  updateDarkMode(storedDarkMode);
}

export function updateDarkMode(mode) {
  const themeBtn = document.querySelector("#themeBtn");
  const linkedin = document.querySelector(".linkedin-home")
  const mail = document.querySelector(".mail-home")
  const github = document.querySelector(".github-home")
  const medium = document.querySelector(".medium-home") 
  const menu = document.querySelector(".menu-icon") 
  const logo = document.querySelector(".logo") 


  if (mode === "enabled") {
    document.body.classList.add("darkmode");
    themeBtn.src = moonwhite;
    linkedin.src = linkedinDark
    mail.src = mailDark
    github.src = githubDark
    medium.src = mediumdark
    menu.src = menu_dark
    logo.src = logo_dark
    // downArrowIcon.src = down_arrow_white;
    // expressImg.src = express_white
  } else {
    document.body.classList.remove("darkmode");
    themeBtn.src = moonblack;
    linkedin.src = linkedinWhite
    mail.src = mailWhite
    github.src = githubWhite
    medium.src = mediumlight
    menu.src = menu_light
    logo.src = logo_white
  }
}

export function handleDarkModeToggle() {
  let currentMode = localStorage.getItem("darkmode");
  if (currentMode === "enabled") {
    currentMode = "disabled";
  } else {
    currentMode = "enabled";
  }
  localStorage.setItem("darkmode", currentMode);
  updateDarkMode(currentMode);
}
